import React from 'react';
import { Image } from '@yme/atoms/image';
import { ImageErrorPlaceholder } from '@yme/atoms/image-error-placeholder';
import { useImageError } from '@yme/hooks/index';
import { useRenditions } from '@yme/hooks/useRenditions';
import { AspectRatio } from '@yme/utils/constants';
import { chooseAccessoryImage } from './helpers';
export function PartsAccessoriesImage({ images, altText, }) {
    const { isImageLoading, onErrorHandler } = useImageError();
    const imageSrc = chooseAccessoryImage(images, isImageLoading);
    const { imageSrcWithDimension } = useRenditions({
        imageSrc,
        isImageExists: isImageLoading,
    });
    const isDefaultImage = !imageSrcWithDimension || !isImageLoading;
    return isDefaultImage ? (React.createElement(ImageErrorPlaceholder, { aspectRatio: AspectRatio.Square, hasBackground: true })) : (React.createElement(Image, { onError: onErrorHandler, src: imageSrcWithDimension, aspectRatio: AspectRatio.Square, alt: altText }));
}
